import { render, staticRenderFns } from "./userGifts.vue?vue&type=template&id=79a19a65&scoped=true"
import script from "./userGifts.vue?vue&type=script&lang=js"
export * from "./userGifts.vue?vue&type=script&lang=js"
import style0 from "./userGifts.vue?vue&type=style&index=0&id=79a19a65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a19a65",
  null
  
)

export default component.exports